import { ActionsObservable, combineEpics, Epic, ofType, StateObservable } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { Actions, ActionTypes, TAction } from '../Actions/Actions';
import { IGameState } from '../Store/store';
import { TutorialActions } from '../../Config/Tutorial';
import { BoosterId } from '../reducers/boosters';
import { Suits } from '../../Tiles/TileSet';

const matchEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string[][]>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.REMOVE_MATCH),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateTutorial.index !== -1),
        map(([action]) => {
            if (action.payload[1][0].includes(Suits.GOLD)) {
                return Actions.tutorialUpdate({
                    actionId: TutorialActions.MATCH_GOLD,
                    payload: null,
                });
            }

            return Actions.tutorialUpdate({ actionId: TutorialActions.MATCH, payload: null });
        })
    );
};

const findEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, number>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.FIND_OBJECT),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateTutorial.index !== -1),
        map(() => Actions.tutorialUpdate({ actionId: TutorialActions.FIND, payload: null }))
    );
};

const boosterAddEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, BoosterId[]>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.ADD_GAME_BOOSTER),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateTutorial.index !== -1),
        map(([action]) =>
            Actions.tutorialUpdate({
                actionId: TutorialActions.ADD_BOOSTER,
                payload: action.payload[0],
            })
        )
    );
};

const boosterActivateEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.ACTIVATE_BOOSTER),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateTutorial.index !== -1),
        map(([action]) =>
            Actions.tutorialUpdate({
                actionId: TutorialActions.ACTIVATE_BOOSTER,
                payload: action.payload,
            })
        )
    );
};

const boosterShowEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.SHOW_BOOSTER),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateTutorial.index !== -1),
        map(([action]) =>
            Actions.tutorialUpdate({
                actionId: TutorialActions.SHOW_BOOSTER,
                payload: action.payload,
            })
        )
    );
};

const boosterRemoveEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.BOOSTER_ACTION_COMPLETE),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateTutorial.index !== -1),
        map(([action]) =>
            Actions.tutorialUpdate({
                actionId: TutorialActions.COMPLETE_BOOSTER,
                payload: action.payload,
            })
        )
    );
};

const dismissEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, number>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.SELECT_TILE, ActionTypes.ADD_GAME_BOOSTER),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateTutorial.index !== -1),
        map(() => Actions.tutorialUpdate({ actionId: TutorialActions.DISMISS }))
    );
};

const tutorialEpic = combineEpics(
    matchEpic,
    findEpic,
    boosterAddEpic,
    boosterActivateEpic,
    boosterShowEpic,
    boosterRemoveEpic,
    dismissEpic
);

export default tutorialEpic;
